import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim();
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: API });

export function authHeaders() {
  const token = localStorage.getItem("dh_admin_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function fetchImpactStats() {
  const { data } = await api.get("/impact-stats");
  return data;
}

export async function fetchProjects() {
  const { data } = await api.get("/projects");
  return data;
}

export async function fetchTiers() {
  const { data } = await api.get("/donations/tiers");
  return data;
}

export async function submitApplication(payload) {
  const { data } = await api.post("/applications", payload);
  return data;
}

export async function createDonationCheckout(payload) {
  const { data } = await api.post("/donations/checkout", payload);
  return data;
}

export async function pollDonationStatus(sessionId) {
  const { data } = await api.get(`/donations/status/${sessionId}`);
  return data;
}

export async function adminLogin(email, password) {
  const { data } = await api.post("/admin/login", { email, password });
  if (data?.token) localStorage.setItem("dh_admin_token", data.token);
  return data;
}

export function adminLogout() {
  localStorage.removeItem("dh_admin_token");
}

export async function adminListApplications() {
  const { data } = await api.get("/applications", { headers: authHeaders() });
  return data;
}

export async function adminUpdateStats(stats) {
  const { data } = await api.put("/impact-stats", stats, { headers: authHeaders() });
  return data;
}

export async function adminUpsertProject(project) {
  if (project.id) {
    const { data } = await api.put(`/projects/${project.id}`, project, { headers: authHeaders() });
    return data;
  }
  const { data } = await api.post("/projects", project, { headers: authHeaders() });
  return data;
}

export async function adminDeleteProject(id) {
  const { data } = await api.delete(`/projects/${id}`, { headers: authHeaders() });
  return data;
}
